import React from 'react';
import { Container, Row, Col } from '../components/grid';
import {
  Heading1,
  Paragraph,
  LinkStyled,
} from '../components/typography';
import Forbrug from '../components/Forbrug';
import SidemenuLayout from '../layout/DefaultLayout/Layouts/SidemenuLayout';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="DetDrakAndre">
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading1>
            Det drak andre kunder til deres fester<br />
          </Heading1>
          <Paragraph bold>Hvor meget fadøl skal jeg købe?</Paragraph>
          <Paragraph>
            Det er ikke altid lige nemt at beregne, hvor fadøl der skal bruges til ens fest.
          </Paragraph>
          <Paragraph>
            Vi har derfor samlet en række oplysninger fra fester vi tidligere har leveret til.
            Prøv at se om du kan finde en fest, der ligner din egen nedenfor.
            Hvis ikke, så skal du være mere en velkommen til at kontakte os på tlf. <LinkStyled anchor to="tel:43270000">43 27 00 00</LinkStyled>
          </Paragraph>
        </Col>
      </Row>
      <Row>
        <Forbrug
          headline="Bryllupsfest på Gods, Lørdag 30. juli"
          hours="10 timer"
          guests="70"
          use="4 Herslev 19 liters."
          glassPrGuest="3,3"
          fadoel="Gratis"
          vin="Ja, gratis"
          spiritus="Ja, gratis"
          mad="Ja"
          paragraph="Sodavand drukket/brugt til både drinks og almindelig brug, i alt 51 liter."
        />
        <Forbrug
          headline="Bryllupsfest, Lørdag 24. september"
          hours="8 timer"
          guests="74"
          use="2 Carlsberg Pilsner"
          glassPrGuest="2,0"
          fadoel="Gratis"
          vin="Ja, gratis"
          spiritus="Ja, gratis"
          mad="Ja"
          paragraph="Sodavand drukket/brugt til både drinks og almindelig brug, i alt 37,5 liter."
        />
        <Forbrug
          headline="Temafest - Softwarevirksomhed"
          hours="kl. 18 til 01"
          guests="480"
          use={(<React.Fragment>10 Grøn Tuborg<br />11 Tuborg Classic</React.Fragment>)}
          glassPrGuest="3,3"
          fadoel="Gratis"
          vin="Ja, gratis"
          spiritus="Ja, gratis"
          mad="Ja"
          paragraph={
            (
              <React.Fragment>
                Sodavand drukket/brugt til både drinks og almindelig brug, i alt 333 liter.<br />
                Tonic, lemon, grøn og rød: 159 liter<br />
                Danskvand med og uden citrus: 24 liter<br />
                Cola, Zero, Fanta, Sprite: 150 liter
              </React.Fragment>
            )
          }
        />
        <Forbrug
          headline="Sommer firmafest - Stort revisorfirma"
          hours="kl. 17 til 02"
          guests="1600"
          use="60 Grøn Tuborg"
          glassPrGuest="2,8"
          fadoel="Gratis"
          vin="Ja, gratis"
          spiritus="Ja, gratis"
          mad="Ja"
          paragraph=""
        />
        <Forbrug
          headline="Reception - Handelsfirma"
          hours="4 timer"
          guests="200"
          use={(<React.Fragment>2 grøn<br />2 classic</React.Fragment>)}
          glassPrGuest="1,5"
          fadoel="Gratis"
          vin="Ja"
          spiritus="Ja"
          mad="Ja, julemad"
          paragraph=""
        />
        <Forbrug
          headline="30 års fødselsdag"
          hours="10 timer"
          guests="44"
          use="2 grøn"
          glassPrGuest="3,4"
          fadoel="Gratis"
          vin="Ja"
          spiritus="Ja"
          mad="Ja"
          paragraph=""
        />
        <Forbrug
          headline="Kandidatfest"
          hours="11 timer"
          guests="90"
          use="9 grøn"
          glassPrGuest="7,5"
          fadoel="Salg, billigt"
          vin="lidt"
          spiritus="Salg, lidt"
          mad="Ja"
          paragraph=""
        />
        <Forbrug
          headline="Fest for venner og bekendte"
          hours="10 timer"
          guests="60"
          use="1 Carls Special"
          glassPrGuest="1,25"
          fadoel="Gratis"
          vin="Ja"
          spiritus="Ja"
          mad="Ja"
          paragraph=""
        />
        <Forbrug
          headline="Villa indflytningsfest"
          hours="12 timer"
          guests="150"
          use="5 alm."
          glassPrGuest="2,5"
          fadoel="Gratis"
          vin="Ja"
          spiritus="Ja"
          mad="Nej"
          paragraph=""
        />
        <Forbrug
          headline="Lærerfest folkeskole"
          hours="7 timer"
          guests="180 - heraf 65% kvinder"
          use={(<React.Fragment>7 grøn<br />5 classic</React.Fragment>)}
          glassPrGuest="5"
          fadoel="15 kr."
          vin="15 kr. pr. glas"
          spiritus="15 kr. pr. drink"
          mad="Ja"
          paragraph=""
        />
        <Forbrug
          headline="1. maj fest (håndværkerfaget)"
          hours="3 timer"
          guests="300 - heraf 2/3 mænd"
          use={(<React.Fragment>10 grøn<br />7 alm.</React.Fragment>)}
          glassPrGuest="4,25"
          fadoel="10 kr."
          vin="Nej"
          spiritus="Lidt gammel dansk"
          mad="Stort morgenmads-bord"
          paragraph=""
        />
        <Forbrug
          headline="Gallafest gymnasium"
          hours="8,5 timer"
          guests="600"
          use={(<React.Fragment>38 grøn<br />14 somersby</React.Fragment>)}
          glassPrGuest="6,5"
          fadoel="15 kr."
          vin="Nej"
          spiritus="Nej"
          mad="Mad for 3.g'erne"
          paragraph=""
        />
        <Forbrug
          headline="Fotograf-studiet Svendegilde"
          hours="20 - 03"
          guests={(<React.Fragment>100<br />50% kvinder</React.Fragment>)}
          use={(<React.Fragment>3 Classic<br />11 kasser sodavand</React.Fragment>)}
          glassPrGuest="4,25"
          fadoel="Gratis"
          vin="Gratis"
          spiritus="Gratis"
          mad="Ja"
          paragraph=""
        />
        <Forbrug
          headline="40 års fødselsdag i selskabslokale"
          hours="14-24"
          guests={(<React.Fragment>70-80<br />50% kvinder</React.Fragment>)}
          use={(<React.Fragment>5 Grøn Tuborg<br />1 Classic<br />1 Carls special</React.Fragment>)}
          glassPrGuest="6,5"
          fadoel="Gratis"
          vin="Gratis"
          spiritus="Gratis"
          mad="Ja"
          paragraph=""
        />
        <Forbrug
          headline="Svendegilde elektromekanikker lejet lokale"
          hours="Lørdag 18-04:30"
          guests="38"
          use="2 Classic"
          glassPrGuest="3,9"
          fadoel="Gratis"
          vin="Gratis"
          spiritus="Gratis"
          mad="Ja"
          paragraph=""
        />
        <Forbrug
          headline="Sommerfest sygeplejersker"
          hours="Lørdag 18-02"
          guests={(<React.Fragment>185<br />90% kvinder</React.Fragment>)}
          use={(<React.Fragment>4 Grøn Tuborg<br />2 Somersby</React.Fragment>)}
          glassPrGuest={(<React.Fragment>1,6<br />0,8</React.Fragment>)}
          fadoel="30 kr."
          vin="Ja salg"
          spiritus="Ja salg"
          mad="Ja"
          paragraph=""
        />
        <Forbrug
          headline="DHL Stafet 2012 - industrivirksomhed"
          hours="18-23 Mildt sommervejr"
          guests="80-100"
          use="4 classic"
          glassPrGuest="3,33"
          fadoel="Nej"
          vin="Nej"
          spiritus="Nej"
          mad="Ja"
          paragraph=""
        />
        <Forbrug
          headline="DHL Stafet 2012 - industrivirksomhed"
          hours="16-01 Mildt sommervejr"
          guests="700-800, 35-60 år"
          use="12 Platan 4,8%"
          glassPrGuest="1,20"
          fadoel="Nej"
          vin="Nej"
          spiritus="Nej"
          mad="Ja"
          paragraph=""
        />
        <Forbrug
          headline="Herlev Festival, firma"
          hours="2 dage Mildt sommervejr"
          guests="700-800, 35-60 år"
          use="41 fustager"
          glassPrGuest="-"
          fadoel="Ja"
          vin="Nej"
          spiritus="Nej"
          mad="Nej"
          paragraph=""
        />
        <Forbrug
          headline="Herlev Festival, Kommune"
          hours="2 dage Mildt sommervejr)"
          guests="-"
          use={(<React.Fragment>10 grøn<br />5 classic</React.Fragment>)}
          glassPrGuest="5,13"
          fadoel="Ja"
          vin="Nej"
          spiritus="Nej"
          mad="Nej"
          paragraph=""
        />
        <Forbrug
          headline="DHL Stafet 2012 - industrivirksomhed"
          hours="18-21 Mildt sommervejr"
          guests={(<React.Fragment>ca. 200, 19-60 år<br />Flest på 30</React.Fragment>)}
          use="3 grøn"
          glassPrGuest="1,13"
          fadoel="Ja"
          vin="Nej"
          spiritus="Nej"
          mad="Nej"
          paragraph="Ja"
        />
        <Forbrug
          headline="Gymnasiefest - 31. aug"
          hours="19-00.30 Mildt sommervejr"
          guests="ca. 300, 17-18 år"
          use="10 grøn"
          glassPrGuest="2,50"
          fadoel="20 kr"
          vin="Nej"
          spiritus="Nej"
          mad="Nej"
          paragraph=""
        />
        <Forbrug
          headline="Sommerfest - 24. aug. 2012"
          hours="17-02.00 Mildt sommervejr"
          guests="78, 35-40 år"
          use="4,5 (2 grøn &amp; 2,5 Classic)"
          glassPrGuest="4,33"
          fadoel="Inkl. I fast pris"
          vin="Ja"
          spiritus="Velkomst drink"
          mad="Ja"
          paragraph=""
        />
        <Forbrug
          headline="325års Jubilæum Brandvæsen"
          hours="Lør. 17-03"
          guests="320, flest mænd"
          use={(<React.Fragment>5 Grøn<br />9 classic</React.Fragment>)}
          glassPrGuest="3,27"
          fadoel="Nej"
          vin="Ja"
          spiritus="Ja"
          mad="Ja"
          paragraph=""
        />
        <Forbrug
          headline="Julefrokost - ansatte seminarium"
          hours="10 timer"
          guests=">80 heraf flest kvinder"
          use={(<React.Fragment>2 Julebryg<br />3 grøn</React.Fragment>)}
          glassPrGuest="4,75"
          fadoel="Salg"
          vin="Ja"
          spiritus="Ja"
          mad="Julemad"
          paragraph=""
        />
        <Forbrug
          headline="Julefrokost - industrivirksomhed"
          hours="7 timer"
          guests="120 heraf 2/3 mænd"
          use="1 alm, 6 sne &amp; 3 somersby"
          glassPrGuest="3,4"
          fadoel="Gratis"
          vin="Ja, lidt vin"
          spiritus="Ja, alkoholsodavand"
          mad="Julemad"
          paragraph=""
        />
        <Forbrug
          headline="Julefrokost - Statsinstitution"
          hours="11 timer"
          guests="364 spisning + 200 efter"
          use="20 alm. &amp; 8 sne"
          glassPrGuest="3,7"
          fadoel="Salg"
          vin="Ja, salg"
          spiritus="Ja, salg"
          mad="Julemad"
          paragraph=""
        />
        <Forbrug
          headline="Julefrokost"
          hours="11 timer"
          guests="14 Grøn, 5 Julebryg"
          use="600"
          glassPrGuest="2,4"
          fadoel="Gratis ml. 19-21, derefter 10 kr."
          vin="Ja, salg"
          spiritus="Ja, salg"
          mad="Julemad"
          paragraph=""
        />
      </Row>
    </Container>
  </SidemenuLayout>
);
